import React from 'react';
import { Alert } from 'react-bootstrap';

const SystemNotification = ({ message, metadata, timestamp, fileAttachment }) => {
  // Helper to format file size
  const formatFileSize = (bytes) => {
    if (!bytes) return '';
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  };

  return (
    <div className="my-3 d-flex justify-content-center">
      <Alert 
        variant="info" 
        className="text-center shadow-sm"
        style={{
          maxWidth: '80%',
          borderRadius: '12px',
          border: '1px solid #0dcaf0',
          backgroundColor: '#e7f6fd',
          padding: '12px 20px'
        }}
      >
        <div className="d-flex align-items-center justify-content-center gap-2">
          <i className="bi bi-info-circle-fill" style={{ fontSize: '1.2rem', color: '#0dcaf0' }}></i>
          <div>
            <strong>{message}</strong>
            
            {/* Display file attachment if present */}
            {fileAttachment && fileAttachment.fileUrl && (
              <div className="mt-2 p-2 rounded" style={{ backgroundColor: '#d1ecf1', border: '1px solid #bee5eb' }}>
                <div className="d-flex align-items-center gap-2 justify-content-center">
                  <img src="/images/files.svg" alt="file" width={16} />
                  <a 
                    href={fileAttachment.fileUrl} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-decoration-none fw-semibold"
                    style={{ color: '#004085' }}
                  >
                    {fileAttachment.fileName}
                  </a>
                  <span className="small text-muted">
                    ({formatFileSize(fileAttachment.fileSize)})
                  </span>
                </div>
              </div>
            )}
            
            {metadata?.actionBy && (
              <div className="small text-muted mt-1">
                by {metadata.actionBy} ({metadata.actionByRole})
              </div>
            )}
            <div className="small text-muted">
              {new Date(timestamp).toLocaleString('en-US', {
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
              })}
            </div>
          </div>
        </div>
      </Alert>
    </div>
  );
};

export default SystemNotification;
